import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { csmBaseUrlResource } from '@jira/router-resources__service-desk-customer-service-csm-base-url/src/csmBaseUrlResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsServiceHubsAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-service-hubs/src/helpCenterSettingsServiceHubsAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { csmExperiencesRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperiencesRoute.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const csmExperiencesPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperiencesRouteEntry: Route = createEntry(csmExperiencesRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.csm-experiences',
	layout: globalLayout,
	navigation: {
		sidebarId: SidebarIdCsmApp,
	},
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmExperiencesPageEntryPoint
			: notFoundPageEntrypoint;
	},
	resources: [
		...getCustomerServiceL1NavigationResources(),
		csmBaseUrlResource,
		customerExperiencesNavigationResource,
	],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
